import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import {
  getMachinePriceStatisticsById,
  IGetMachinePriceStatisticsByIdReturn,
  IGetMachinePriceStatisticsParam,
} from '../../../../api/marketPrice/queries/getMachinePriceStatisticsById';
import { AxiosError } from 'axios';
import { machinePriceStatisticsApiUrl } from '../../../../api/marketPrice/queries/getMachinePriceStatistics';

interface IUseGetMachinePriceStatisticsByIdQueryParams extends IGetMachinePriceStatisticsParam {
  options?: UseQueryOptions<IGetMachinePriceStatisticsByIdReturn | null, AxiosError>;
}

export const useGetMachinePriceStatisticsById = ({
  machineId,
  options,
}: IUseGetMachinePriceStatisticsByIdQueryParams) => {
  return useQuery<IGetMachinePriceStatisticsByIdReturn | null, AxiosError>(
    [machinePriceStatisticsApiUrl, machineId],
    () => getMachinePriceStatisticsById({ machineId }),
    {
      ...options,
      enabled: options?.enabled === false ? false : Boolean(machineId),
    },
  );
};
